import { WHATSAPP_LINK } from "../lib/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK("Hello Royale Yaan, I'd like to enquire")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 ry-float group flex items-center gap-3 bg-[#128C7E] hover:bg-[#0E6B5F] text-white rounded-full shadow-lg shadow-black/20 pl-4 pr-5 py-3 transition-all"
      aria-label="Chat on WhatsApp"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.5 0 .17 5.32.17 11.86c0 2.09.55 4.13 1.6 5.93L0 24l6.39-1.68a11.84 11.84 0 0 0 5.66 1.44h.01c6.54 0 11.86-5.32 11.86-11.86 0-3.17-1.23-6.15-3.4-8.42ZM12.06 21.7h-.01a9.81 9.81 0 0 1-5-1.37l-.36-.21-3.79 1 1.01-3.69-.23-.38a9.84 9.84 0 0 1-1.51-5.21c0-5.44 4.43-9.86 9.88-9.86 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.9 6.98c0 5.44-4.43 9.84-9.88 9.84Zm5.41-7.36c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.96-.94 1.16c-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.51-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.51.07-.78.37-.27.3-1.02 1-1.02 2.44s1.05 2.83 1.2 3.03c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35Z"/>
      </svg>
      <span className="text-sm font-medium hidden sm:inline">Chat with us</span>
    </a>
  );
}
